import { Plus } from 'lucide-react';
import { motion, useReducedMotion } from 'motion/react';
import { t, tr } from '@/i18n';
import { BUILTIN_TEMPLATES } from '@lumo/shared';
import { useCreateBoard } from './BoardsPage';
import { TemplateCard } from './TemplatesPage';

/** Быстрый старт: пустая доска и популярные шаблоны. */
export function QuickStart({ workspaceId, extra }: { workspaceId: string; extra?: React.ReactNode }) {
  const create = useCreateBoard();
  const reduce = useReducedMotion();
  return (
    <section className="mt-7" aria-label={t('dashboard.quickStart')}>
      <h2 className="mb-3 text-[11px] font-semibold tracking-wide text-fg-subtle uppercase">{t('dashboard.quickStart')}</h2>
      <div className="flex gap-4 overflow-x-auto pb-2">
        <motion.button
          type="button"
          whileHover={reduce ? undefined : { y: -2 }}
          whileTap={reduce ? undefined : { scale: 0.98 }}
          onClick={() => create({ workspaceId })}
          className="group flex w-44 shrink-0 flex-col overflow-hidden rounded-panel bg-surface text-left shadow-card transition-shadow hover:shadow-float"
        >
          <span className="canvas-dots flex aspect-[16/10] items-center justify-center">
            <span className="inline-flex size-11 items-center justify-center rounded-full bg-accent text-white shadow-float transition-transform group-hover:scale-110">
              <Plus className="size-5" />
            </span>
          </span>
          <span className="px-3 py-2.5 text-[13px] font-medium">{t('dashboard.blankBoard')}</span>
        </motion.button>
        {BUILTIN_TEMPLATES.filter((t) => ['builtin:retro-ssc', 'builtin:kanban', 'builtin:mindmap', 'builtin:flowchart', 'builtin:brainstorm', 'builtin:swot'].includes(t.id)).map((tpl) => (
          <TemplateCard key={tpl.id} tpl={tpl} compact onPick={() => void create({ workspaceId, templateId: tpl.id, name: tr(tpl.name) })} />
        ))}
        {extra}
      </div>
    </section>
  );
}
